// menu page id constant
export const MENU_PAGE_GENIESMART = 101;
export const MENU_PAGE_REVISION = 102;
export const MENU_PAGE_PROGRESS = 103;
export const MENU_PAGE_GENIECLASS = 104;
export const MENU_PAGE_LEADERBOARD = 105;
export const MENU_PAGE_GENIEASK = 106;
export const MENU_PAGE_ACCOUNT = 107;

// feature id constant
export const FEATURE_STUDY_PLAN = 101;
export const FEATURE_WEEKLY_PROGRESS = 102;
export const FEATURE_EXAM_RESULT = 103;
export const FEATURE_BADGES = 104;
export const FEATURE_STREAK = 105;
export const FEATURE_GENERATE_WORKSHEET = 106;
